module.exports = __webpack_public_path__ + "static/media/reach_us_icon.f28afb71.svg";